/* ============================================================
   Keoki Shop - Un unico H1 en la portada

   El carrusel duplica la primera diapositiva para poder hacer el
   bucle con efecto de fundido. Esas copias llevan el atributo
   data-item-cloned y arrastran una copia del H1, de modo que el
   DOM acababa con dos H1 aunque el HTML servido solo tuviera uno.

   Este script degrada a <span> el H1 de las copias, dejando un
   unico H1 semantico: el de la diapositiva original.
   ============================================================ */
(function () {
  'use strict';

  function degradarClones(raiz) {
    var clones = (raiz || document).querySelectorAll('[data-item-cloned] h1');

    for (var i = 0; i < clones.length; i++) {
      var h1 = clones[i];
      var span = document.createElement('span');

      span.className = h1.className;
      span.innerHTML = h1.innerHTML;
      span.setAttribute('aria-hidden', 'true');

      if (h1.parentNode) {
        h1.parentNode.replaceChild(span, h1);
      }
    }
  }

  function iniciar() {
    degradarClones(document);

    var slider = document.querySelector('.slideshow ul.slider');
    if (!slider || typeof MutationObserver === 'undefined') return;

    var observador = new MutationObserver(function () {
      degradarClones(document);
    });

    observador.observe(slider, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
